import React from "react";
import { Circles } from "react-loader-spinner";

const LoaderSpinner = ({
  Loader = Circles,
  height = "80",
  width = "80",
  color = "#FE6432",
  ariaLabel = "circles-loading",
  style = "mt-60",
}) => {
  return (
    <div className={`flex justify-center items-center ${style}`}>
      <Loader
        height={height}
        width={width}
        color={color}
        ariaLabel={ariaLabel}
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default LoaderSpinner;
